import { Instagram, Mail, MapPin } from "lucide-react";
import { useT } from "@/i18n/LanguageProvider";

export default function Footer() {
  const { t } = useT();
  return (
    <footer
      data-testid="footer"
      className="relative w-full grain"
      style={{ background: "#211512", color: "#FFF8EE" }}
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <h3
            className="font-logo"
            style={{ fontSize: "clamp(2.4rem, 6vw, 5rem)", lineHeight: 1 }}
          >
            TIRAMI
          </h3>
          <p className="font-serif italic text-[#FFF8EE]/60 mt-4 max-w-md text-lg">
            {t("footer.tagline")}
          </p>

          
        </div>

        <div className="md:col-span-3">
          <p className="label-tracked text-[#C5A059]">{t("footer.visit")}</p>
          <p className="font-serif text-2xl mt-4 leading-snug">
            Monterrey,
            <br />
            Nuevo León
          </p>
          <p className="label-tracked text-[#FFF8EE]/60 mt-4">
            {t("footer.hours")}
          </p>
        </div>

        <div className="md:col-span-3">
          <p className="label-tracked text-[#C5A059]">{t("footer.reach")}</p>
          <ul className="mt-4 space-y-3 text-[#FFF8EE]/80">
            <li className="flex items-center gap-3">
              <Mail className="w-4 h-4" /> tirami.info@gmail.com
            </li>
            <li className="flex items-center gap-3">
              <a
                href="https://www.instagram.com/tirami.mx"
                target="_blank"
                rel="noreferrer noopener"
                className="flex items-center gap-3 text-[#FFF8EE]/80 hover:text-[#FFF8EE]"
              >
                <Instagram className="w-4 h-4" /> @Tirami.mx
              </a>
            </li>
            <li className="flex items-center gap-3">
              <MapPin className="w-4 h-4" /> {t("footer.directions")}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-[#FFF8EE]/10">
        <div className="mx-auto max-w-[1500px] px-6 md:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-[#FFF8EE]/50 text-xs">
          <p>© {new Date().getFullYear()} Tirami. {t("footer.rights")}</p>
          <p className="label-tracked">{t("footer.made")}</p>
        </div>
      </div>
    </footer>
  );
}
